export default {"src":"/_next/static/media/carbon_footprint.6afe31d6.svg","height":96,"width":96};